/* eslint-disable jira/filename-case */
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const updateProductSettingsFinancialYear = (initialMonth: number): Promise<void> =>
	performPutRequest('/rest/polaris/product-settings/financial-year', {
		body: JSON.stringify({
			initialMonth,
		}),
	});

export const updateProductSettingsViewBlueprints = (
	viewBlueprintsEnabled: boolean,
): Promise<void> =>
	performPutRequest('/rest/polaris/product-settings/view-blueprints', {
		body: JSON.stringify({
			enabled: viewBlueprintsEnabled,
		}),
	});
